import React, { Component } from 'react';
import AllRoutes from './routes/AllRoutes';
import { ToastContainer } from 'react-toastify';
import { connect } from 'react-redux';
import Layout from './components/layout/Layout'
import { IsLoggedIn } from './helper/HelperAuth'
import StoreActionLogout from './store/action/LogoutAction'
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';

class App extends Component {
    constructor(props) {
        super(props);
    
        this.events = [
          "load",
          "mousemove",
          "mousedown",
          "click",
          "scroll",
          "keypress"
        ];
    
        //this.warn = this.warn.bind(this);
        this.logout = this.logout.bind(this);
        this.resetTimeout = this.resetTimeout.bind(this);
    
        for (var i in this.events) {
          window.addEventListener(this.events[i], this.resetTimeout);
        }
       
        this.setTimeout();
      }
    
      clearTimeout() {
        if (this.logoutTimeout) clearTimeout(this.logoutTimeout);
      }
    
      setTimeout() {
       // this.warnTimeout = setTimeout(this.warn, 10 * 1000);
        if(window.location.pathname.toLowerCase() !== "/login" && window.location.pathname.toLowerCase() !== "/"){
          this.logoutTimeout = setTimeout(this.logout, 900 * 1000);
        }
      }
    
      resetTimeout() {
        this.clearTimeout();
        this.setTimeout();
      }
    
      warn() {
        alert("You will be logged out automatically in 1 minute.");
      }
    
      async logout() {
        // Send a logout request to the API
        alert("You were automatically logged out because no activity");
        console.log("Sending a logout request to the API...");
        await this.props.ActionLogout();
        // this.destroy(); // Cleanup
      }
    
      destroy() {
        this.clearTimeout();
    
        for (var i in this.events) {
          window.removeEventListener(this.events[i], this.resetTimeout);
        }
      }



    populateTemplate() {
        if(IsLoggedIn){
            return (
                <Layout>
                    <AllRoutes />
                </Layout> 
            );
        }
        else{
            return <AllRoutes />
        }
    }

    render() {
        return (
            <span style={{height: "100%",}}>
                { this.populateTemplate() }
                <ToastContainer />
            </span>
        );
    }
}

export default connect(
    (state) => {
        return {
            isLoggedIn: state.auth.isLoggedIn,
        }
    },
    dispatch => bindActionCreators({
        ActionLogout: StoreActionLogout,
    }, dispatch),
)(App);